import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import SlaCategoriesTable from './SlaCategoriesTable';
import AddSlaCategories from './AddSlaCategories';
import Download from '../../MainSection/Download/Download';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadSettingsSlaData, loadSingleSettingsSlaData, postSettingsSlaCategoriesData } from '../../../redux/action';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from '../../../Constants';
import SlaCategoriesColumnFilter from './SlaCategoriesColumnFilter';
import SlaCategoriesValueFilter from './SlaCategoriesValueFilter';
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import SlaCategoriesBulkUploadModal from './SlaCategoriesBulkUploadModal';

const statusOptions = [
    { value: 14, label: "Active" },
    { value: 15, label: "Inactive" }
]

const SlaCategories = () => {

    let dispatch = useDispatch();
    const { id: userRefId } = useParams();

    const { SettingSlaData } = useSelector((state) => state.data);
    const { SingleSettingSlaData } = useSelector((state) => state.data);
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID'));

    const [loading, setLoading] = useState(true);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [settingsSlaId, setSettingsSlaId] = useState("");
    const [selectedColumns, setSelectedColumns] = useState([
        "SLA CHECKLIST", "STATUS", "ACTION"
    ]);
    const [selectedStatusID, setSelectedStatusID] = useState(null);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);

    const handleStatusSelection = (selectedOption) => {
        if (selectedOption) {
            const statusID = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedStatusID(statusID);  // Store StatusID in state
            getSettingsSlaData(statusID);  // Call API with both StatusID and current RoleID
        }
    };

    useEffect(() => {
        if (userRefId) {
            dispatch(loadSingleSettingsSlaData(setDataLoading, userRefId));
        } else {
            getSettingsSlaData();
        }
    }, [userRefId]);

    const getSettingsSlaData = (statusID) => {
        dispatch(loadSettingsSlaData(setLoading, statusID));
    }
    // useEffect(() => {
    //     getSettingsSlaData()
    // }, []);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = (settSlaId) => {
        setIsModalOpen(true);
        if (settSlaId) {
            dispatch(loadSingleSettingsSlaData(setDataLoading, settSlaId))
            setSettingsSlaId(settSlaId);
        } else {
            setSettingsSlaId("");
        }
    };

    const handleCloseModal = () => {
        setSettingsSlaId("");
        dispatch(loadSingleSettingsSlaData(setDataLoading, null));
        setIsModalOpen(false);
    };

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const handleStatusChange = (customer, statusLabel) => {
        const statusID = statusLabel === "Active" ? 14 : 15; // 14 for Active, 15 for Inactive

        // console.log(customer, 'customer')
        const data = {
            SLACategoriesID: customer.SLACategoriesID,
            SLACategoriesName: customer.SLACategoriesName,
            StatusID: statusID,
            AddedByID: ADDED_BY_ID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postSettingsSlaCategoriesData(requestOption, handleCloseModal, getSettingsSlaData, customer.SLACategoriesID));
        // console.log(data, 'data'); // For debugging purposes
    };

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const handleClearFilters = () => {
        setSelectedStatusID(null);
        getSettingsSlaData();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / SLA Checklist"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>SLA Checklist</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3} className='filters-col'>
                                    <Select
                                        className="react-select-container complaint-status-select"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        options={statusOptions}
                                        style={{ width: "100%" }}
                                        value={selectedStatusID ? statusOptions.find(status => status.value === selectedStatusID) : null}
                                        onChange={(selectedOption) => handleStatusSelection(selectedOption)}
                                    />
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {/* {(signInDetails[0]?.SignInType !== 'ClientAdmin' || PreviousCompanyID) && <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} />} */}
                                {(signInDetails[0]?.SignInType !== 'ClientAdmin' || PreviousCompanyID) && <SbDropdownButton
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <SlaCategoriesTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                SettingSlaData={SettingSlaData}
                                loading={loading}
                                handleStatusChange={handleStatusChange}
                                selectedColumns={selectedColumns}
                                signInDetails={signInDetails}
                                PreviousCompanyID={PreviousCompanyID}
                                SingleSettingSlaData={SingleSettingSlaData}
                                userRefId={userRefId}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddSlaCategories
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    getSettingsSlaData={getSettingsSlaData}
                    SingleSettingSlaData={SingleSettingSlaData}
                    settingsSlaId={settingsSlaId}
                    dataLoading={dataLoading}
                />
            }
            {
                showBulkUploadModal && <SlaCategoriesBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                    getSettingsSlaData={getSettingsSlaData}
                />
            }
            {showColumnFilterModal && (
                <SlaCategoriesColumnFilter
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {showValueFilterModal && (
                <SlaCategoriesValueFilter
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {/* {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default SlaCategories;